// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"wether-info_infoCardContainer__yQf0S","todayBackground":"wether-info_todayBackground__qDQAR"};